import "@/App.css";
import { useEffect } from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import Landing from "@/pages/Landing";
import Game from "@/pages/Game";
import AuthCallback from "@/pages/AuthCallback";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";
import Friends from "@/pages/Friends";
import Room from "@/pages/Room";
import Pricing from "@/pages/Pricing";
import Privacy from "@/pages/Privacy";
import Terms from "@/pages/Terms";
import { installAntiTamper, loadRecaptcha } from "@/lib/security";
import { GeoProvider } from "@/lib/geo";
import { KEYWORD_SLUGS } from "@/lib/seoKeywords";

function AppRouter() {
  return (
    <Routes>
      <Route path="/" element={<Game />} />
      {/* Programmatic-SEO keyword landing routes — each renders the Landing
          UI with keyword-specific <head> tags + hero copy. These stay on
          Landing so they own their own dedicated SEO surface. */}
      {KEYWORD_SLUGS.map((slug) => (
        <Route
          key={slug}
          path={`/${slug}`}
          element={<Landing seoSlug={slug} />}
        />
      ))}
      {/* /game preserved as an alias for old bookmarks/backlinks — renders the
          same game-first homepage. Canonical URL is `/` (see _redirects). */}
      <Route path="/game" element={<Game />} />
      <Route path="/friends" element={<Friends />} />
      <Route path="/room/:code" element={<Room />} />
      <Route path="/pricing" element={<Pricing />} />
      <Route path="/privacy" element={<Privacy />} />
      <Route path="/privacy-policy" element={<Privacy />} />
      <Route path="/terms" element={<Terms />} />
      <Route path="/terms-of-service" element={<Terms />} />
      <Route path="/auth/google" element={<AuthCallback />} />
      <Route path="/admin" element={<AdminLogin />} />
      <Route path="/admin/dashboard" element={<AdminDashboard />} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

function App() {
  useEffect(() => {
    // Anti-tamper: right-click + DevTools shortcuts. Anti-debug loop stays
    // OFF in dev (interferes with hot-reload). Set antiDebug:true for prod.
    installAntiTamper({ antiDebug: false });
    // Load reCAPTCHA v3 silently (no-op if REACT_APP_RECAPTCHA_SITE_KEY not set)
    loadRecaptcha();
  }, []);

  return (
    <div className="App">
      <BrowserRouter>
        <GeoProvider>
          <AppRouter />
          <Toaster theme="dark" position="top-right" />
        </GeoProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
